import Swiper from 'swiper';
import { Mousewheel } from 'swiper/modules';
import { initComponent } from './core/init-component';

initComponent('.js-features-carousel', (element) => {
  const swiper = new Swiper(element, {
    modules: [Mousewheel],

    slidesPerView: 1.4,
    slidesPerGroup: 1,
    spaceBetween: 80,
    touchEventsTarget: 'container',
    speed: 300,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: false,
      sensitivity: 1,
    },
    breakpoints: {
      744: {
        slidesPerView: 2.55,
        spaceBetween: 80,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 136,
      },
      1366: {      
        slidesPerView: 3,  
        spaceBetween: 176,
      },
    },
  });

  return {
    unload() {
      swiper.destroy();
    },
  };
});
